import FpuPermissionsComponentTypeInterface from "@app/Interface/FpuPermissionsComponentViewInterface";
import ProducerInterface from "@app/Interface/ProducerInterface";
import User from "@app/Interface/UserInterface";
import FpuPermissionsComponentType from "@app/Type/FpuPermissionsComponentType";
import ProducerModel from "./ProducerModel";
import UserModel from "./UserModel";

export default class FpuPermissionsComponentTypeModel implements FpuPermissionsComponentTypeInterface {
    fpuId: number;
    producer: ProducerInterface;
    userId: number;
    user: User;
    component: FpuPermissionsComponentType;

    constructor(producerId?: number, producer?: ProducerInterface, userId?: number, user?: User, component?: FpuPermissionsComponentType) {
        this.fpuId = producerId ?? 0;
        this.producer = producer ?? new ProducerModel();
        this.userId = userId ?? 0;
        this.user = user ?? new UserModel();
        this.component = component ?? "FpuPermissions";
    }
    

}